import useSentryContextSync from '@hooks/useSentryContextSync';

/**
 * Renderless mount point for `useSentryContextSync`. Kept as its own component so
 * the session/hotel-chain subscriptions it needs re-render nothing but itself.
 */
export const SentryContextSync = (): null => {
  useSentryContextSync();

  return null;
};

export default SentryContextSync;
